// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RdfH","left":"styles_left__3EtLC"};